// extracted by mini-css-extract-plugin
module.exports = {"collection":"ConsentsCollection_collection__XKXvu","item":"ConsentsCollection_item__sSScj","header":"ConsentsCollection_header__36fw6"};